import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import get from 'lodash/get';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import 'Features/Product/components/ProductCommerce/GiftCardEditions.scss';

const GiftCardOptions = ({
  product,
}) => {
  if (!product || !product.editions || !product.editions.length) {
    return false;
  }

  return (
    <React.Fragment>
      <div className="mb-1">
        <FormattedMessage id="giftcardeditions.amount" defaultMessage="Amount" />
      </div>
      <div className="GiftCardEditions">
        {product.editions.map(edition =>
          <Link to={`/gift-card/${edition.slug}`} className={classNames('GiftCardEditions__edition', { 'GiftCardEditions__edition--active': edition.slug === product.slug })} key={edition._id} title={edition.name}>
            {get(edition, 'edition_name', edition.name).replace(' Edition', '')}
          </Link>,
        )}
      </div>
    </React.Fragment>
  );
};

GiftCardOptions.propTypes = {
  editions: PropTypes.arrayOf(PropTypes.object),
};

GiftCardOptions.defaultProps = {
  editions: [],
};

export default GiftCardOptions;
